













import { Vue, Component } from "@/shared/vuepack";
import { useUserStore } from "@/shared/store/user";

@Component({})
export default class PasswordRequirements extends Vue {
  userStore = useUserStore();

  get passwordMinLength () {
    return this.userStore.passwordMinLength;
  }
}
